import Cookies from 'js-cookie'

const isLogin = () => {
    return !!getUserInfo().token
}

const userProps = {
    token: 'token',
    name: 'name',
    orgName: 'orgName',
    userId: 'UserID',
    orgGid: 'orgGid'
}

// 往cookie中设置用户信息
const setUserInfo = (userInfo) => {
    Cookies.set(userProps.token, userInfo.token)
    Cookies.set(userProps.name, userInfo.userName)
    Cookies.set(userProps.orgName, userInfo.orgName)
    Cookies.set(userProps.userId, userInfo.userId)
    Cookies.set(userProps.orgGid, userInfo.orgGid)
}

//清除cookie
const clearUserInfo = (userInfo) => {
    Cookies.remove(userInfo.token)
    Cookies.remove(userInfo.userName)
    Cookies.remove(userInfo.orgName)
    Cookies.remove(userInfo.userId)
    Cookies.remove(userInfo.orgGid)
}

const getUserId = () => {
    return getUserInfo().userId
}

const getUserInfo = () => {
    return {
        token: Cookies.get(userProps.token),
        name: Cookies.get(userProps.name),
        orgName: Cookies.get(userProps.orgName),
        orgGid: Cookies.get(userProps.orgGid),
        userId: Cookies.get(userProps.userId)
    }
}

export {
    isLogin,
    setUserInfo,
    clearUserInfo,
    getUserId,
    getUserInfo
}



// WEBPACK FOOTER //
// ./src/common/utils/user_info.js